(() => {
  const popup = document.getElementById('pf-opening-popup');
  if (!popup || popup.dataset.initialized || typeof popup.showModal !== 'function') return;
  popup.dataset.initialized = 'true';
  const key = 'pf-opening-2026-10-eur-seen';
  const repeat = 7 * 24 * 60 * 60 * 1000;
  const expires = Date.parse(popup.dataset.expires);
  const serverNow = Number(popup.dataset.serverNow) * 1000;
  const started = performance.now();
  const now = () => Math.max(Date.now(), serverNow + performance.now() - started);
  let previousFocus;
  let previousOverflow;
  let openTimer;
  const wasSeen = () => {
    let last = 0;
    try { last = Math.max(last, Number(localStorage.getItem(key)) || 0); } catch (_) {}
    try { last = Math.max(last, Number(sessionStorage.getItem(key)) || 0); } catch (_) {}
    const cookie = document.cookie.split('; ').find(item => item.startsWith(key + '='));
    if (cookie) last = Math.max(last, Number(cookie.slice(key.length + 1)) || 0);
    return last > 0 && now() - last < repeat;
  };
  const markSeen = () => {
    const value = String(now());
    try { localStorage.setItem(key, value); } catch (_) {}
    try { sessionStorage.setItem(key, value); } catch (_) {}
    document.cookie = key + '=' + value + '; Path=/; Max-Age=604800; SameSite=Lax; Secure';
  };
  const dismiss = () => { if (popup.open) popup.close(); };
  popup.querySelector('.pf-opening-close').addEventListener('click', dismiss);
  popup.querySelector('.pf-opening-dismiss').addEventListener('click', dismiss);
  popup.querySelector('.pf-opening-shop').addEventListener('click', dismiss);
  popup.addEventListener('click', event => {
    if (event.target !== popup) return;
    const bounds = popup.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dismiss();
  });
  popup.addEventListener('close', () => {
    document.documentElement.style.overflow = previousOverflow;
    if (previousFocus && previousFocus.isConnected) previousFocus.focus({ preventScroll: true });
  });
  const expire = () => {
    if (now() >= expires) { clearTimeout(openTimer); dismiss(); popup.remove(); return; }
    setTimeout(expire, Math.min(expires - now(), 60000));
  };
  const otherDialogOpen = () => Array.from(document.querySelectorAll('dialog[open], [role="dialog"]')).some(element => {
    if (element === popup || element.closest('#pf-opening-popup') || element.closest('[aria-hidden="true"]')) return false;
    const style = getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) !== 0 && element.getClientRects().length > 0;
  });
  const show = () => {
    if (now() >= expires || wasSeen()) return;
    if (document.hidden || otherDialogOpen()) { openTimer = setTimeout(show, 1000); return; }
    previousFocus = document.activeElement;
    previousOverflow = document.documentElement.style.overflow;
    popup.showModal();
    document.documentElement.style.overflow = 'hidden';
    markSeen();
  };
  window.addEventListener('pageshow', () => { if (now() >= expires) expire(); });
  document.addEventListener('visibilitychange', () => { if (!document.hidden && now() >= expires) expire(); });
  if (now() >= expires) { popup.remove(); return; }
  expire();
  if (!wasSeen()) openTimer = setTimeout(show, 4000);
})();
